// extracted by mini-css-extract-plugin
export var component = "ArticleRelatedPosts-module--component--XJ24u";
export var inner = "ArticleRelatedPosts-module--inner--YSNNF";
export var item = "ArticleRelatedPosts-module--item--WKflS";
export var link = "ArticleRelatedPosts-module--link--ecGFZ";
export var list = "ArticleRelatedPosts-module--list--E7-XA";
export var title = "ArticleRelatedPosts-module--title--HqsiB";